import serviceTaskRunner, { services, _callRestfulService as restful } from "../lib/restful/services/restAPIs";
import { cleanUpTempValues } from "../lib/util/Util";

export const APP_INFO  = async (values, proccess) => {
  cleanUpTempValues(values);
    let result =  {
        APPLICATION:{
          CONTACT_EMAIL:"contact_us@digitstash.com",
          COPYRIGHT_LABEL:"DigitStash. All rights reserved.",
          ENV:"UNKNOWN",
          ENV_LABEL:"",
          SEO_IMG:"https://www.digitstash.com/digitstash.png",
          SEO_URL:"https://www.digitstash.com"
        },
        RUNTIME: {
          RUN_MODE: 'DEBUG',
          ANNOUNCEMENT: { MESSAGE: '', STATE: 'RUNNING' },
          AUTHORIZATION_REQUIRED: true,
          STATUS: 'MAINTENANCE',
          ROUTE_PAGES:[{
            PATH:"/*",
            PAGE:"Splash"
          }
         ]
        }
      }
   let resultx = await serviceTaskRunner(services.APP_INFO)(
    values.app_name, values.info_type, {}, 
    async (response, callParams) => {
      const data = response.data.payload;
      proccess(data);
      result = data;
    
      return result;
    },
    {
      //callBack Parameters
    },
    (error) => {
      //throw { message: "Unable to get app info" };
    }
  );
  
  return result?result:resultx ;
};          